import { PreloadedQuery, usePreloadedQuery } from "react-relay";

import { anchorPageRelayQuery } from "@/__generated_contentful__/anchorPageRelayQuery.graphql";
import {
    AnchorPageRelayQuery,
    shapeAnchorContentfulResponse
} from "@/contentful/graphql/anchor-page";
import { AnchorContentsResponse } from "@/utils/anchor-queries/get-anchor-contents";

// @ts-expect-error missing module declaration
import { JiraSoftwarePageProps } from "./jira-software-page";
import { JiraSoftwarePagePaidLpJswAnchor } from "./paid-lp-jsw-anchor";

export interface JiraSoftwarePagePaidLpJswAgileRelayProps
    extends JiraSoftwarePageProps {
    anchorContents?: AnchorContentsResponse | null;
    persona?: string;
    queryRef?: PreloadedQuery<anchorPageRelayQuery>;
}

export const JiraSoftwarePagePaidLpJswAgile = (
    pageProps: JiraSoftwarePagePaidLpJswAgileRelayProps
) => {
    const data = usePreloadedQuery(
        AnchorPageRelayQuery,
        pageProps.queryRef ||
            (null as unknown as PreloadedQuery<anchorPageRelayQuery>)
    );

    return (
        <JiraSoftwarePagePaidLpJswAnchor
            {...pageProps}
            anchorContents={shapeAnchorContentfulResponse(data)}
            pageId="paid-lp-jsw-agile"
            persona="unknown"
            pageVariant="agile"
        />
    );
};
